import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class OwnTheLook extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }
    var slickSettings = {
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: true,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    let heroImage = null;
    const heroBanner = pagedetails.heroBanner;
    let heroImageUrl = '';
    heroImageUrl =
      heroBanner.imageUrl.indexOf('?') == -1
        ? heroBanner.imageUrl
        : heroBanner.imageUrl.substr(0, heroBanner.imageUrl.indexOf('?'));
    heroImage = (
      <div className="hero-image">
        <a
          href={heroBanner.urlLink}
          data-ga-event-category="bannerTap"
          data-ga-event-action={`${sectionName}/${heroBanner.componentPosition}/${widgetType}`}
          data-ga-event-label={`${heroImageUrl}/${heroBanner.bannerPosition}`}
          data-gtm-bnr-position={`${heroBanner.componentPosition}`}
          data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(heroBanner.imageUrl) || ''}`}
          data-gtm-bnr-id={`${heroBanner.uId || ''}`}
        >
          <img src={`${replaceWithJioCDN(heroBanner.imageUrl)}`} />
        </a>
      </div>
    );

    var arr = [];
    bannerDetail.map((bannerimagedetails, j) => {
      arr.push({
        id: j,
        uId: bannerimagedetails.uId,
        imageUrl: bannerimagedetails.imageUrl,
        bannerPos: bannerimagedetails.bannerPosition,
        componentPos: bannerimagedetails.componentPosition
      });
    });

    let imageGallery = arr.map((data, i) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        data.imageUrl.indexOf('?') == -1
          ? data.imageUrl
          : data.imageUrl.substr(0, data.imageUrl.indexOf('?'));
      return (
        <Col xs={3} key={i} className="gallery-section">
          <a
            href={data.urlLink}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${data.componentPos}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${data.bannerPos}`}
            data-gtm-bnr-position={`${data.componentPos}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(data.imageUrl) || ''}`}
            data-gtm-bnr-id={`${data.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(data.imageUrl)}`} />
          </a>
        </Col>
      );
    });

    let imageList;
    //  console.log(arr.length)

    if (arr.length > 1) {
      imageList = (
        <Slider {...slickSettings} ref="slick">
          {imageGallery}
        </Slider>
      );
    } else {
      imageList = imageGallery;
    }

    return (
      <div className="gallery-com ownlook">
        <div className="overlap-gallery">
          {heroImage}
          <div className="gallery-cont">{imageList}</div>
        </div>
      </div>
    );
  }
}

export default BannerWrapper(OwnTheLook);
